module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#speaker",
      toString: function () {
        return this.url;
      }
    }